import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {
  useCancelCorrectiveTaxDocumentMutation,
  useCancelInvoiceMutation,
  useCancelInvoiceProformaMutation,
} from '@dms/api/finance';

import {Nullish} from 'shared/web';

import {InvoiceTypes} from '../types/InvoiceTypes';
import {handleApiError} from '../utils/handleApiError';

export const useCancelAccountingDocument = () => {
  const [
    cancelProformaDocument,
    {isLoading: loadingProformaDocument, isError: isProformaDocumentError},
  ] = useCancelInvoiceProformaMutation();
  const [
    cancelInvoiceDocument,
    {isLoading: loadingInvoiceDocument, isError: isInvoiceDocumentError},
  ] = useCancelInvoiceMutation();
  const [
    cancelCorrectiveTaxDocument,
    {isLoading: loadingCorrectiveTaxDocument, isError: isCorrectiveTaxDocumentError},
  ] = useCancelCorrectiveTaxDocumentMutation();

  const isLoading =
    loadingProformaDocument || loadingInvoiceDocument || loadingCorrectiveTaxDocument;

  const isError = isProformaDocumentError || isInvoiceDocumentError || isCorrectiveTaxDocumentError;

  const cancelDocument = async (invoiceType: InvoiceTypes | Nullish, documentId: string) => {
    if (isNil(invoiceType)) {
      showNotification.error();
      return;
    }

    const cancelPromise = match(invoiceType)
      .with('PROFORMA', () =>
        cancelProformaDocument({
          invoiceProformaId: documentId,
        })
      )
      .with('CORRECTIVE_TAX_DOCUMENT', () =>
        cancelCorrectiveTaxDocument({
          correctiveTaxDocumentId: documentId,
        })
      )
      .otherwise(() => cancelInvoiceDocument({invoiceId: documentId}));

    await cancelPromise.unwrap().catch(handleApiError);
  };

  return [cancelDocument, {isLoading, isError}] as const;
};
